import type { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import editingSessions from './editing-sessions';
import persistence from './persistence';

export default function* root(): SagaIterator {
  yield all([fork(persistence), fork(editingSessions)]);
}
